// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Hi7h","clinicsSelect":"TableHeading_clinicsSelect__21KYP"};